import {isDarkColor} from '@wix/panda-js-utils'
import {useWidgetProps} from './widget-props'

export const useColors = () => {
  const widgetProps = useWidgetProps()

  const getActionColor = () =>
    widgetProps.host.style.siteColors.find((color: any) => color.reference === 'color-8').value

  const getLinkColor = () => widgetProps.host.style.styleParams.colors?.readMoreTextColor?.value || getActionColor()

  const isDarkActionColor = () => isDarkColor(getActionColor())

  const isDarkLinkColor = () => isDarkColor(getLinkColor())

  return {
    isDarkActionColor,
    isDarkLinkColor,
  }
}
